




















































































































































































































import Draggable from 'vuedraggable';

import {
  WorkflowFormFieldTypeEnum,
  IWorkflowFormFieldData,
  IWorkflowFormFieldOptionSubmissionData,
  IWorkflowFormFieldSubmissionData,
  IWorkflowFormSectionData,
  IWorkflowFormSectionFieldData
} from '@/models';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import { PropType } from 'vue';
import Proxyable from '@/mixins/proxyable';

import DatePicker from '../common/DatePicker.vue';
import DragDropFileInput from '../common/DragDropFileInput.vue';
import DeleteConfirmationDialog from '../common/DeleteConfirmationDialog.vue';
import WorkflowFormBuilderField from './WorkflowFormBuilderField.vue';
import WorkflowFormBuilderFieldOptionsButton from './WorkflowFormBuilderFieldOptionsButton.vue';
import { extractTextFromHtml } from '@/utils/helpers';

export interface IMoveDragData {
  moved: {
    element: IWorkflowFormSectionFieldData;
    newIndex: number;
    oldIndex: number;
  };
}

export interface IAddDragData {
  added: { element: IWorkflowFormSectionFieldData; newIndex: number };
}

export interface IRemoveDragData {
  removed: { element: IWorkflowFormSectionFieldData; oldIndex: number };
}

export default mixins(auth, Proxyable).extend({
  components: {
    DatePicker,
    DeleteConfirmationDialog,
    DragDropFileInput,
    Draggable,
    WorkflowFormBuilderField,
    WorkflowFormBuilderFieldOptionsButton
  },

  props: {
    value: Object as PropType<IWorkflowFormSectionData>,
    disabled: Boolean
  },

  inject: {
    //FormBuilderDetailPage view component
    formBuilder: {
      default: {}
    }
  },

  data() {
    return {
      WorkflowFormFieldTypeEnum,
      deleteFieldDialog: false
    };
  },

  computed: {
    selectedFieldIndex: {
      get(): number {
        return (this as any).formBuilder.selectedFieldIndex;
      },
      set(val) {
        (this as any).formBuilder.selectedFieldIndex = val;
      }
    }
  },

  methods: {
    extractTextFromHtml,

    setSelectedIndex(index: number) {
      this.selectedFieldIndex = index;
    },

    // Returns a unique id for a section field (prefers section-field id, falls back to template id)
    getSectionFieldUniqueId(field: IWorkflowFormSectionFieldData): number {
      return (field.field_template as IWorkflowFormFieldData).id!;
    },

    // Extracts the template pointer from a field (adjust the property name to your schema)
    getTemplatePointer(field: IWorkflowFormSectionFieldData): number | null {
      return (
        ((field.field_template as IWorkflowFormFieldData).template as number) ??
        null
      );
    },

    // Checks if a field is a child of some template field
    isChildField(field: IWorkflowFormSectionFieldData): boolean {
      return this.getTemplatePointer(field) != null;
    },

    // Returns children belonging to a given Template field
    getChildFields(
      templateField: IWorkflowFormSectionFieldData
    ): IWorkflowFormSectionFieldData[] {
      const templateIds = [
        (templateField.field_template as IWorkflowFormFieldData).id
      ].filter(Boolean);

      return (this.internalValue
        .section_fields as IWorkflowFormSectionFieldData[]).filter(
        sectionField => {
          const templatePointer = this.getTemplatePointer(sectionField);
          return (
            templatePointer != null && templateIds.includes(templatePointer)
          );
        }
      );
    },

    reorderTemplateSectionFields(
      data: IMoveDragData | IAddDragData | IRemoveDragData
    ) {
      this.internalValue.section_fields = (this
        .internalValue as IWorkflowFormSectionData).section_fields.map(
        (fields, i) => {
          return {
            ...fields,
            order: i
          };
        }
      );

      //when moving from one section to the other, this method gets called twice
      //added and remove data comes in but we only want to save on added
      if ((data as IRemoveDragData).removed) return;

      if ((data as IMoveDragData).moved) {
        const index = (data as IMoveDragData).moved.newIndex;
        this.setSelectedIndex(index);
      } else if ((data as IAddDragData).added) {
        const index = (data as IAddDragData).added.newIndex;
        this.setSelectedIndex(index);
      }

      this.$emit('save');
    },

    removeTemplateSectionField() {
      this.internalValue.section_fields.splice(this.selectedFieldIndex!, 1);
      this.$emit('save');
      this.deleteFieldDialog = false;
    },

    editTemplateSectionField() {
      this.$emit('openDrawer', this.selectedFieldIndex);
    },

    cancelFieldDeleteDialog() {
      this.deleteFieldDialog = false;
    },

    genRadioBtnOptionsValue(
      radio: IWorkflowFormFieldSubmissionData,
      submissons: IWorkflowFormFieldOptionSubmissionData[]
    ): IWorkflowFormFieldOptionSubmissionData {
      let value = submissons.find(submisson => submisson.option == radio.id);

      if (!value) {
        value = {
          option: radio.id
        } as IWorkflowFormFieldOptionSubmissionData;
      }

      return value;
    },

    genLabel(section_field: IWorkflowFormSectionFieldData) {
      let label = (section_field.field_template as IWorkflowFormFieldData)
        .label;
      if (section_field.required) {
        label = `${label}*`;
      }
      return label;
    },

    genHint(section_field: IWorkflowFormSectionFieldData) {
      return (section_field.field_template as IWorkflowFormFieldData).hint;
    }
  }
});
